import { Image, RecipeNode } from '../api/types.js';

/**
 * A node's displayed image: always its own explicit `imageUrl` — no more
 * derivation from an ingredient/transformation source. Centralized here
 * (rather than inlined at each call site) mainly for readability/intent and
 * as a seam if node image resolution ever needs another layer again.
 */
export function getNodeImageUrl(data: RecipeNode): string | undefined {
  return data.imageUrl;
}

/**
 * An ingredient's/transformation's default image: the one flagged default,
 * else the first (oldest) one, else none if the pool is empty. Mirrors the
 * backend's `default_image_url()` in receptari/model/recipe.py.
 */
export function getDefaultImageUrl(images: Image[] | undefined): string | undefined {
  if (!images || images.length === 0) return undefined;
  return images.find(img => img.isDefault)?.url ?? images[0].url;
}
